const styles = () => ({
  image: { maxWidth: '100%', maxHeight: '100%' },
  variantImageContainer: { height: 60, width: 'auto' }
});

export default styles;
